angular.module('bmsApp.settings').controller('TextlocalSettingsCtrl', function ($scope,
																				$timeout,
																				AppSettingsSvc,
																				notify) {

	var form = {
		validatorConfig: {
			submitHandler: function () {
				$timeout(function () {
					form.processing = true;
					self.errors = null;
					AppSettingsSvc.update(form.settingsData)
						.then(function (response) {
							notify({
								message: 'Settings saved'
							});
							form.settingsData = response.data.settings;
						}, function (errors) {
							self.errors = errors;
						})
						.finally(function () {
							form.processing = false;
						})
					;
				});
			}
		},
		validatorApi: {},
		settingsData: {},
		processing: false
	};

	var self = {
		methods: {
			init: function () {
				AppSettingsSvc.index()
					.then(function (response) {
						form.settingsData = response.data.settings;
					}, function (errors) {
						self.errors = errors;
					})
					.finally(function () {
						self.loading = false;
					});
			}
		},
		form: form,
		loading: true,
		errors: null
	};

	$scope.TextlocalSettingsCtrl = self;

});
